<template>
  <div>
    <a href="javascript:void(0)" class="text--underline font-16" @click.prevent="getYamatoShipping(rowData)">送料確認</a>
    <yamato-shipping-info-modal
      v-if="showYamatoShippingInfoModal"
      :shippingInfoTable="yamatoShippingInfoTable"
      @close="closeModalYamatoShippingInfo"
    />
  </div>
</template>

<script>
import ProductService from '@/services/productservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import YamatoShippingInfoModal from '@/components/YamatoShippingInfoModal'

export default {
  props: {
    rowData: {
      type: Object,
      default () {
        return {}
      }
    },
    checkFrom: {
      type: String,
      default: 'list'
    }
  },
  components: {
    YamatoShippingInfoModal
  },
  data () {
    return {
      loader: null,
      yamatoShippingInfoTable: '',
      showYamatoShippingInfoModal: false,
      scrollNumber: null
    }
  },

  methods: {
    getYamatoShipping (product) {
      this.trackLogGetShipping(product)
      this.loader = this.$loading.show()
      ProductService.getYamatoShipping()
        .then(response => {
          this.loader && this.loader.hide()
          this.yamatoShippingInfoTable = response.data
          this.openModalYamatoShippingInfo()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openModalYamatoShippingInfo () {
      this.scrollNumber = $(window).scrollTop()
      this.showYamatoShippingInfoModal = true
    },
    closeModalYamatoShippingInfo () {
      this.showYamatoShippingInfoModal = false
      $('#yamato-shipping-info-modal').modal('hide')
      $('#yamato-shipping-info-modal').on('hidden.bs.modal', () => {
        window.scrollTo(0, this.scrollNumber)
      })
    },
    trackLogGetShipping (product) {
      if (this.checkFrom && ['list', 'add-by-amazon'].includes(this.checkFrom)) {
        let logParamsName = eventCode.manage_products.list_tab.check_shipping_fee
        if (this.checkFrom === 'add-by-amazon') {
          logParamsName = eventCode.manage_products.add_by_amazon_tab.check_shipping_fee
        }
        let logParams = {
          name: logParamsName,
          properties: {
            asin: product.asin
          }
        }
        EventService.postTrackLog(logParams)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/YamatoShippingFee.vue